// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"0314a7b9","190":"201092d1","392":"cbe260ce","971":"2e1ef812"}[chunkId] + ".chunk.js";
};